module.exports = __webpack_public_path__ + "img/allegro.5335d978.png";